module.exports = __webpack_public_path__ + "img/logo-teladan.92c35585.png";